import React from "react";

import { useSingleUser } from "../hook/useUser";

import { IUser } from "../../auth/types/user.types";

import { dateConverter } from "../../../utils/dateConverter";

import { limitString } from "../../../utils/stringUtils";

import StatusBox from "../../../components/atoms/StatusBox/StatusBox";

export type UserInfoObject = IUser;

export interface UserInfoProps {
  info: keyof UserInfoObject;
  id?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    goTo: () => void;
  }) => JSX.Element;
}

const statusConverterUser = (status: string) => {
  const statusLower = status.toLowerCase();
  
  switch (statusLower) {
    case "active":
      return (
        <StatusBox
          color={{
            background: "#D0F0C5",
            text: "#4F6E44",
          }}
          label="Actif"
        />
      );
    case "inactive":
      return (
        <StatusBox
          color={{
            background: "#F0C5C5",
            text: "#6E4444",
          }}
          label="Inactif"
        />
      );
    default:
      return (
        <StatusBox
          color={{
            background: "#EDF0F1",
            text: "#000000",
          }}
          label={status}
        />
      );
  }
};

export default function UserInfo({
  info,
  id,
  emptyText,
  styled,
  limitText,
}: UserInfoProps) {
  const {
    singleQuery: { isLoading, isError, data },
  } = useSingleUser(id || "");

  const attributUser = info as keyof IUser;

  if (isLoading) return <>...</>;

  if (isError) return <>{emptyText ? emptyText : ""}</>;

  const userData = data as IUser | undefined;
  
  if (info === "user_status" && styled && userData?.user_status) {
    return statusConverterUser(userData.user_status);
  }

  const convertValue = (info: keyof UserInfoObject, value: any) => {
    switch (info) {
      case "user_creation_date":
        return dateConverter(value);
      case "user_update_date":
        return dateConverter(value);
      case "birthdate":
        return dateConverter(value);
      case "user_is_active":
        return value ? "Oui" : "Non";
      case "from_employee":
        return value ? "Oui" : "Non";
      case "active_notif":
        return value ? "Oui" : "Non";
      default:
        return value;
    }
  };

  const value = userData?.[attributUser];

  return (
    <>
      {value !== undefined && value !== null && value !== ""
        ? limitString(
            String(convertValue(info, value)),
            limitText
          )
        : emptyText
        ? emptyText
        : ""}
    </>
  );
}
